import styled from "styled-components";


export const Container = styled.div`
  label{
    display: block;
    color: #000;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 16px;
  }

  input{
    padding: 8px 10px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    border: 1px solid #96989A;
    border-right: none;
    flex: 1;
  }


  div{
    display: flex;
  }

  .pre_url {
    background-color: #E8E8E8;
    color: #96989A;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 8px 16px;
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
  }

  .info_container{
    position: relative;
    cursor: pointer;
    height: fit-content;
  }

  .msg_container{
    position: absolute;
    padding: 10px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #F2F2F2;
    width: 300px;
    left: 10px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  p{
    margin: 0;
    color: #FF0000;
  }

  span {
    font-size: 0.8rem;
    padding: 0.25rem;
  }
`;
